import React, { Component } from "react";

import UserImage from "../../user_image";
import ListMedia from "./list_media";
import { Link } from "react-router-dom";
class ListAnswerSquare extends Component {
  state = {};
  render() {
    return (
      <div
        className="width_answer_media_v2 answer_square_v2 pt-2"
        style={{ display: "inline-block" }}
      >
        <Link
          to={"/users/" + this.props.answer.user.username}
          style={{ flex: 1 }}
        >
          <div className="answer_square_row_user_v2">
            <div className="image-profile">
              <div style={{ marginTop: "3px" }}>
                <UserImage user={this.props.answer.user} link={false} />
              </div>
            </div>
            <div className="user">
              <label className="name">
                {this.props.answer.user.first_name}{" "}
                {this.props.answer.user.last_name}
              </label>
              <label className="username">
                {this.props.answer.user.username}
              </label>
            </div>
          </div>
        </Link>
        {/* <UserImage user={this.props.answer.user} bottomImage={true} /> */}
        <ListMedia answer={this.props.answer} row={false} />
      </div>
    );
  }
}

export default ListAnswerSquare;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_answer_square.jsx